import * as React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined";
// import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import swal from "sweetalert";
import { Editor } from "@tinymce/tinymce-react";
import avtarPic from "../../../assets/Images/avtarPic.png";

import {
  makePostRequest,
  makeGetRequest,
  uploadFileRequest,
} from "../../../utils/utils";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useState, useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Zoom from "react-medium-image-zoom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ReplayCircleFilledIcon from "@mui/icons-material/ReplayCircleFilled";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function NewConversationModal({ onSubmitModal }) {
  const [postTitle, setPostTitle] = useState("");
  const [postDesc, setPostDesc] = useState("");
  const [attachment, setAttachment] = useState([]);
  const [membersIds, setMembersIds] = useState([]);
  const [radiovalue, setradioValue] = useState("");
  const [isIndividual, setIsIndividual] = useState(false);
  const [q, setQ] = React.useState("");
  const [residentlist, setresidentlist] = React.useState([]);
  // const [postObj, setPostObj] = React.useState([]);
  const [Upload, setUpload] = React.useState(false);
  const [, setActiveIndex] = React.useState();
  const [errradio, seterrradio] = React.useState(false);
  const [errDesc, seterrDesc] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [isSelectGroup, setIsSelectGroup] = React.useState(false);
  const [groupsList, setGroupsList] = React.useState([]);
  const [selectedGroup, setSelectedGroup] = React.useState();

  const [group_name, setGroupName] = React.useState("");
  const [group_description, setGroupDesc] = React.useState("");
  const [open3, setOpen3] = React.useState(false);
  const [scroll] = React.useState("paper");
  const [showerr, setshowerr] = React.useState(false);
  const [iseditflag, setiseditflag] = React.useState(false);
  const [postId, setpostId] = React.useState();
  const [docErrorMsg, setDocErrorMsg] = React.useState("");

  let memberArr = [];

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };

  const Validation_Schema = Yup.object().shape({
    postTitle: Yup.string()
      .trim("White spaces not allow")
      .strict(true)
      .required("Required"),
    postDesc: Yup.string(),
    // attachment: Yup.string().required("Required"),
    radiovalue: Yup.string(),
  });

  if (iseditflag) {
    var formikInitials = {
      postTitle: postTitle,
      postDesc: postDesc,
      radiovalue: radiovalue,
      membersIds: membersIds,
    };
  } else {
     formikInitials = {
      postTitle: "",
      postDesc: "",
      radiovalue: "",
    };
  }

  const handleChangeradio = (e) => {
    seterrradio(false);
    setshowerr(false);
    memberArr.length = 0;
    membersIds.length = 0;
    setIsIndividual(false);
    setIsSelectGroup(false);
    setSelectedGroup();
    let selectedVal = e.target.value;

    let userFlag = "";
    setradioValue(selectedVal);
    if (selectedVal === "individual") {
      setIsIndividual(true);
      setIsSelectGroup(false);
      residentlisting();
    } else if (selectedVal === "Groups") {
      setIsSelectGroup(true);
      GetAllGroups();
    } else {
      setIsSelectGroup(false);
      userFlag = selectedVal;
      // setShowLoader(true);
      setradioValue(userFlag);

    }
  };

  async function GetAllGroups() {
    await makeGetRequest("group/getAllGroups/" + localStorage.getItem("userId"))
      .then((response) => {
        if (response.status === 201) {
          setGroupsList(response.data.data.rows);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function handleChangeGroup (e){
    console.log(e.target.value);
    setShowLoader(true);
    setshowerr(false);
    // setgroupid(gId)
    setSelectedGroup(e.target.value);
    await makeGetRequest("group/getgroupmember/" + e.target.value)
      .then((response) => {
        if (response.status === 201) {
          setMembersIds(response.data.data.member_id);
          console.log(response.data.data.member_id);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  };

  async function createGroup() {
    if(group_name == '' || group_name == undefined) {
      swal("warning","Group name should not be empty","warning");
      return false
    }
    else if (
      group_description == '' || group_description == undefined) {
        swal("warning","Description should not be empty","warning");
      return false
    } else if (membersIds.length == 0) {
      swal("warning","Please select at least one member","warning");
      return false
    } else {
      setShowLoader(true)
      let groupData;
    let inputdata;
    inputdata = {
      group_name: group_name,
      group_description: group_description,
      resident_id: parseInt(localStorage.getItem("userId")),
    };
    await makePostRequest("group/createGroup", inputdata)
      .then((response) => {
        if (response.data.status === "1") {
          groupData = {
            group_id: response.data.data.group_id,
            member_id: membersIds,
          };
        }
      })
      .catch((err) => {
        setShowLoader(false)
        swal("There was an error!", "more error details", "warning");
      });

      if(groupData)
      {
        await makePostRequest("group/addGroupMember", groupData)
        .then((response) => {
          if (response.data.status === "1") {
            swal("Success", "Group created successfully", "success", {
              timer: 1000,
              buttons: false,
            });
            setGroupName('');
            setGroupDesc("")
            setOpen3(false);
            setShowLoader(false)
          }
        })
        .catch((err) => {
          setShowLoader(false)
          swal("There was an error!", "more error details", "warning");
        });
      }
    }
  }

  const handleClickOpen3 = (scrollType) => () => {
    // setSelectedGroup()
    memberArr.length = 0;
    membersIds.length = 0;
    residentlisting();
    setOpen3(true);
    // setradioValue("")
  };

  const handleClose3 = () => {
    setGroupName('');
    setGroupDesc("")
    setOpen3(false);
  };

  const handleChangeSelectedResident = (residentId) => {
    setshowerr(false);
    // membersIds.push(residentId);
    // setMembersIds(membersIds);
    setMembersIds((memIds) => {
      const index = memIds.indexOf(residentId);
      if (index !== -1) {
        //remove
        const updatedIds = [...memIds];
        updatedIds.splice(index, 1);
        return updatedIds;
      } else {
        //add
        return [...memIds, residentId];
      }
    });
    setActiveIndex(residentId);
  };

  function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  
  async function uploadfile(e) {
    setDocErrorMsg("");
    const file = e.target.files[0];
    if (validateImageOrFile(file)) {
      setShowLoader(true);
      var profilePicUrl = await addattachment(file);

      attachment.push(profilePicUrl);
      setAttachment(attachment);
      // setUpload(!Upload);
      setShowLoader(false);
    } else {
      setShowLoader(false);
      setDocErrorMsg("Invalid file format");
    }
  }

  async function addattachment(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    let fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
        console.log(response.data.imagepath[0]);
        // let filename = response.data.imagepath[0].originalname;
        // setFilename(filename);
      }
    );
    return fileUrl;
  }

  async function deleteDocument(index) {
    attachment.splice(index, 1); // 2nd parameter means remove one item only
    setAttachment(attachment);
    console.log("fil", Upload);
    setUpload(!Upload);
  }
  async function residentlisting() {
    setShowLoader(true);
    let bodyFormData = {
      searchq: q,
      pageNo: "",
      count: "",
      // isTenent:""
    };

    await makePostRequest("resident/residentandtenentlisting", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data.rows);
          const data = response.data.data.rows;
          setresidentlist(data);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handleEditorChange = (content, editor) => {
    seterrDesc(false);
    setPostDesc(content);
  };

  async function addPost() {
    // e.preventDefault();
    var inputdata = "";
    if (postDesc === "") {
      seterrDesc(true);
      return false;
    } else {
      seterrDesc(false);
    }

    if (radiovalue === "") {
      seterrradio(true);
      return false;
    } else {
      seterrradio(false);
      if (
        radiovalue === "all" ||
        radiovalue === "committeeMembers" ||
        radiovalue === "allOwners"
      ) {

        let bodyFormData = "";
        let optn = '';
        if(radiovalue === "all") {
          optn = "All"
        } else if(radiovalue === "allOwners") {
          optn = "Owners"
        } else if(radiovalue === "committeeMembers") {
          optn = "Committee Members"
        } else if(radiovalue === "individual") {
          optn = "individual"
        } else if (radiovalue === "Groups") {
          optn = "Groups"
        } else {
          optn = radiovalue
        }

        await makeGetRequest("post/getallMembersid/" + radiovalue, bodyFormData)
          .then((response) => {
            if (response.status === 201) {
              for (var i = 0; i < response.data.data.length; i++) {
                memberArr.push(response.data.data[i].resident_id);
              }
              setMembersIds(memberArr);
            } 
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });

          if(memberArr)
          {
            // setShowLoader(true);
            inputdata = {
              post_title: postTitle,
              description: postDesc,
              fileuploaded: attachment,
              post_visible_flag: optn,
              sender_id: localStorage.getItem("userId"),
              member_id: memberArr,
              is_new: true,
              ...(radiovalue === "Groups" ? { group_id: selectedGroup } : {}),
            };

            setShowLoader(true);
            await makePostRequest("post/addpost", inputdata)
              .then((response) => {
                console.log(response);
                if (response.status == "201") {
                  swal("Success", "Post created successfully", "success", {
                    timer: 1000,
                    buttons: false,
                  });
                  setShowLoader(false);
                  onSubmitModal();
                }
              })
              .catch((err) => {
                setShowLoader(false);
                swal("There was an error!", "more error details", "warning");
                console.log("Something went wrong!!", err);
              });
          }
      } else {
        if (membersIds.length > 0) {
          setshowerr(false);
          let optn = '';
          if(radiovalue === "all") {
            optn = "All"
          } else if(radiovalue === "allOwners") {
            optn = "Owners"
          } else if(radiovalue === "committeeMembers") {
            optn = "Committee Members"
          } else if(radiovalue === "individual") {
            optn = "individual"
          } else if (radiovalue === "Groups") {
            optn = "Groups"
          } else {
            optn = radiovalue
          }

          inputdata = {
            post_title: postTitle,
            description: postDesc,
            fileuploaded: attachment,
            post_visible_flag: optn,
            sender_id: localStorage.getItem("userId"),
            member_id: membersIds,
            is_new: true,
            ...(radiovalue === "Groups" ? { group_id: selectedGroup } : {}),
          };

          setShowLoader(true);
          await makePostRequest("post/addpost", inputdata)
            .then((response) => {
              console.log(response);
              if (response.status == "201") {
                swal("Success", "Post created successfully", "success", {
                  timer: 1000,
                  buttons: false,
                });
                setShowLoader(false);
                onSubmitModal();
              }
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
              console.log("Something went wrong!!", err);
            });
        } else {
          setshowerr(true);
        }
      }
    }
  }

  // edit
  async function editPost() {
    // e.preventDefault();
    var inputdata = "";
    if (postDesc === "") {
      seterrDesc(true);
      return false;
    } else {
      seterrDesc(false);
    }

    if (radiovalue === "") {
      seterrradio(true);
      return false;
    } else {
      seterrradio(false);
      if (
        radiovalue === "All" ||
        radiovalue === "Committee Members" ||
        radiovalue === "Owners"
      ) {
        let optn = '';
          if(radiovalue === "All") {
            optn = "all"
          } else if(radiovalue === "Owners") {
            optn = "allOwners"
          } else if(radiovalue === "Committee Members") {
            optn = "committeeMembers"
          } else if(radiovalue === "individual") {
            optn = "individual"
          } else if (radiovalue === "Groups") {
            optn = "Groups"
          } else {
            optn = radiovalue
          }
        let bodyFormData = "";
        setShowLoader(true);
        await makeGetRequest("post/getallMembersid/" + optn, bodyFormData)
          .then((response) => {
            if (response.status === 201) {
              for (var i = 0; i < response.data.data.length; i++) {
                memberArr.push(response.data.data[i].resident_id);
              }
              setMembersIds(memberArr);
            } 
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });

          if(memberArr)
          {
            
              // setShowLoader(true);
              inputdata = {
                postid: postId,
                post_title: postTitle,
                description: postDesc,
                fileuploaded: attachment,
                post_visible_flag: radiovalue,
                // sender_id: localStorage.getItem('userId'),
                member_id: memberArr,
                is_new: true,
                ...(radiovalue === "Groups"
                  ? { group_id: parseInt(selectedGroup) }
                  : {}),
              };

              console.log("inp", inputdata);
              await makePostRequest("post/updatepost", inputdata)
                .then((response) => {
                  console.log(response);
                  if (response.status == "200") {
                    swal("Success", "Post update successfully", "success", {
                      timer: 1000,
                      buttons: false,
                    });
                    setShowLoader(false);
                    onSubmitModal();
                  }
                })
                .catch((err) => {
                  setShowLoader(false);
                  swal("There was an error!", "more error details", "warning");
                  console.log("Something went wrong!!", err);
                });
          }
      } else {
        if (membersIds.length > 0) {
          setshowerr(false);

          let optn = '';
          if(radiovalue === "all") {
            optn = "All"
          } else if(radiovalue === "allOwners") {
            optn = "Owners"
          } else if(radiovalue === "committeeMembers") {
            optn = "Committee Members"
          } else if(radiovalue === "individual") {
            optn = "individual"
          } else if (radiovalue === "Groups") {
            optn = "Groups"
          } else {
            optn = radiovalue
          }

          inputdata = {
            postid: postId,
            post_title: postTitle,
            description: postDesc,
            fileuploaded: attachment,
            post_visible_flag: optn,
            // sender_id: localStorage.getItem('userId'),
            member_id: membersIds,
            is_new: true,
            ...(radiovalue === "Groups"
              ? { group_id: parseInt(selectedGroup) }
              : {}),
          };

          setShowLoader(true);
          await makePostRequest("post/updatepost", inputdata)
            .then((response) => {
              console.log(response);
              if (response.status == "200") {
                swal("Success", "Post update successfully", "success", {
                  timer: 1000,
                  buttons: false,
                });
                setShowLoader(false);
                onSubmitModal();
              }
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
              console.log("Something went wrong!!", err);
            });
        } else {
          setshowerr(true);
        }
      }
    }
  }

  async function getPostById(pId) {
    await makeGetRequest("post/viewpostbyid/" + pId)
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data[0].post_visible_flag);
          setPostTitle(response.data.data[0].post_title);
          setPostDesc(response.data.data[0].description);
          setAttachment(response.data.data[0].fileuploaded);
          setpostId(response.data.data[0].postid);

          setradioValue(response.data.data[0].post_visible_flag);
          setMembersIds(response.data.data[0].member_id);

          if (response.data.data[0].post_visible_flag == "individual") {
            residentlisting();
          }
          if (response.data.data[0].post_visible_flag == "Groups") {
            setSelectedGroup(response.data.data[0].group_id);
            GetAllGroups();
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  useEffect(() => {
    if (localStorage.getItem("editpostId")) {
      getPostById(localStorage.getItem("editpostId"));
      setiseditflag(true);
    }
  }, []);

  useEffect(() => {
    if (q) {
      residentlisting();
    }
  }, [q, Upload, membersIds]);

  return (
    <>
      <div id="successfullAdd">
        {iseditflag ? (
          <Formik
            enableReinitialize
            initialValues={formikInitials}
            validationSchema={Validation_Schema}
            onSubmit={editPost}
          >
            {({
              values,
              handleChange,
              errors,
              setFieldTouched,
              touched,
              isValid,
              handleSubmit,
            }) => (
              <Form>
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="modalInput">
                      <MailOutlineIcon />
                      <input
                      maxLength={255}
                        className="modalInputSt"
                        placeholder="Title of message"
                        value={values.postTitle}
                        onChange={handleChange("postTitle")}
                        onBlur={() => setFieldTouched("postTitle")}
                        onChangeCapture={(e) => setPostTitle(e.target.value)}
                      />
                    </div>
                    {errors.postTitle && touched.postTitle ? (
                      <div style={{ color: "red" }} className="errorField">
                        {errors.postTitle}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Editor
                      value={postDesc}
                      onChangeCapture={(e) =>
                        setPostDesc(e.target.getContent())
                      }
                      apiKey="brwlomyki3gc9tg0cfqxjgiy1zgqnfeyzm3kbaakj209n34c"
                      plugins="wordcount"
                      onEditorChange={handleEditorChange}
                    />
                    {errDesc ? (
                      <div style={{ color: "red" }} className="errorField">
                        {"Required"}
                      </div>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="atchmentMain">
                      <div className="atchMain">
                        <AttachmentOutlinedIcon />
                        <input
                          type="file"
                          id="attachmentid"
                          value={values.attachment}
                          onChange={(event) => uploadfile(event)}
                        />
                        <span>Add attachment</span>
                        <span className="formatNot">
                        Note: format allowed for document- (pdf,image,docs,xls,text)
                      </span>
                      </div>
                    </div>
                    <div className="fileName">
                      {attachment.length > 0 ? (
                        <>
                          {attachment.map((option, index) => (
                            <span className="uploaderFileOut">
                              {option.split("/").pop().replace("%20", " ")}
                              <IconButton>
                                <CloseIcon
                                  onClick={() => deleteDocument(index)}
                                />
                              </IconButton>
                            </span>
                          ))}
                        </>
                      ) : (
                        <span>No File uploaded</span>
                      )}
                      {/* <span>sampleimage.jpg</span> */}
                    </div>
                    {docErrorMsg && (
                      <div className="errorField errorFieldFForLogin forInvalidFile">
                        {docErrorMsg}
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="checkWrapper">
                      {iseditflag && (
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          value={radiovalue}
                          onChange={(e) => handleChangeradio(e)}
                          name="radio-buttons-group"
                          className="modalRadioOutNotic"
                        >
                          <FormControlLabel
                            value="All"
                            control={<Radio />}
                            label="All"
                          />
                          <FormControlLabel
                            value="Committee Members"
                            control={<Radio />}
                            label="Committee Members"
                          />
                          <FormControlLabel
                            value="Owners"
                            control={<Radio />}
                            label="All Owners"
                          />
                          <FormControlLabel
                            value="individual"
                            control={<Radio />}
                            label="Individual"
                          />
                          <FormControlLabel
                            value="Groups"
                            control={<Radio />}
                            label="Groups"
                          />
                        </RadioGroup>
                      )}
                    </div>
                  </Grid>
                  {(isSelectGroup || radiovalue == "Groups") && (
                    <Grid item xs={12} md={12}>
                      <div className="refreshOut">
                        <select
                          className="modalInputStSelect"
                          value={selectedGroup}
                          onChange={handleChangeGroup}
                        >
                          <option>Select Group</option>
                          {groupsList.length > 0 ? (
                            <>
                              {groupsList.map((option) => (
                                <option
                                  key={option.group_id}
                                  value={option.group_id}
                                  data-isd={option.group_name}
                                >
                                  {option.group_name}
                                </option>
                              ))}
                            </>
                          ) : (
                            <></>
                          )}
                        </select>
                        {showerr ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required"}
                          </div>
                        ) : null}
                        <div className="refreshList">
                          <ReplayCircleFilledIcon />
                        </div>
                      </div>
                      <div className="orDivider">
                        <span>OR</span>
                      </div>
                      <div className="cretaeGroupLink">
                        <a onClick={handleClickOpen3("body")}>
                          Create New Group
                        </a>
                      </div>
                    </Grid>
                  )}
                  <>
                    {isIndividual ? (
                      <Grid item xs={12} md={12}>
                        <div className="visitorSearchDiv visitorSearchDivNotice">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search by phone"
                            onChangeCapture={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>

                        <div className="forNoticeSelectListOuter">
                          {residentlist.map((option) => (
                            <div
                              key={option.resident_id}
                              className={
                                membersIds.includes(option.resident_id)
                                  ? "visitContDiv visitContDivNotice selectedTile draftSection"
                                  : "visitContDiv visitContDivNotice draftSection"
                              }
                              onClick={() =>
                                handleChangeSelectedResident(option.resident_id)
                              }
                            >
                              <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                                {option.apartment ? (
                                  <>
                                    {/* {option.apartment.} */}
                                    {option.apartment.map((resApt, index) => (
                                      <>
                                        {resApt.is_current_stay == true &&
                                        (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                          // {setTempCurrentStay(true)}
                                          <div className="NewTailCountOut miniBox">
                                            <div className="buildingNameNcount">
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[0]
                                                }
                                              </p>
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[1]
                                                }
                                              </p>
                                            </div>
                                            <h1>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[2]
                                              }
                                            </h1>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    ))}
                                    {option.currentstaycnt.count == 0 &&
                                    (option.user_type == "Resident User" || option.user_type ==
                                      "Admin Owner") ? (
                                      <div className="NewTailCountOut defaultTailCount miniBox">
                                        <div className="buildingNameNcount">
                                          <p>No Apart.</p>
                                          <p>Occupied</p>
                                        </div>
                                        <h1>F-000</h1>
                                      </div>
                                    ) : (
                                      <></>
                                    )}

                                    {option.user_type == "tenent" && (
                                      <>
                                        {option.apartment.map(
                                          (resApt, index) => (
                                            <div className="NewTailCountOut miniBox">
                                              <div className="buildingNameNcount">
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[0]
                                                  }
                                                </p>
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[1]
                                                  }
                                                </p>
                                              </div>
                                              <h1>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[2]
                                                }
                                              </h1>
                                            </div>
                                          )
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <div className="NewTailCountOut defaultTailCount miniBox">
                                      <div className="buildingNameNcount">
                                        <p>No Apart.</p>
                                        <p>Occupied</p>
                                      </div>
                                      <h1>F-000</h1>
                                    </div>
                                  </>
                                )}

                                <div className="visitContProf">
                                  {option.user_obj.profile_pic ? (
                                    <Zoom>
                                      <img src={option.user_obj.profile_pic} />
                                    </Zoom>
                                  ) : (
                                    <img alt="Remy Sharp" src={avtarPic} />
                                  )}
                                </div>
                                <div className="visitContLeft">
                                  <h3 className="visitContHed">
                                    {option.user_obj.first_name}{" "}
                                    {option.user_obj.last_name}{" "}
                                  </h3>
                                  <p className="visitContMob">
                                    {option.user_obj.contact_no}
                                  </p>
                                </div>
                                <div className="visitBottCont forMyTexAlign">
                                  {option.apartment ? (
                                    <div>
                                      <>
                                        {option.apartment.map((opt) => (
                                          <>
                                            {(opt.is_current_stay == true ||
                                              opt.occupancy_type == "Vacant") &&
                                              (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                              <b className="visitContMob">
                                                {opt.uniq_apt_name}
                                                <em>{opt.occupancy_type}</em>
                                                <br />
                                              </b>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        ))}
                                      </>

                                      {option.user_type == "tenent" && (
                                        <>
                                          {option.apartment.map(
                                            (opt1, index) => (
                                              <b className="visitContMob">
                                                {opt1.uniq_apt_name}
                                                <em>{opt1.occupancy_type}</em>
                                              </b>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <div>No Apartment Allocated</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        {showerr ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required"}
                          </div>
                        ) : null}
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </>
                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button type="submit" className="modalMainBt">
                        Update
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        ) : (
          <Formik
            enableReinitialize
            initialValues={formikInitials}
            validationSchema={Validation_Schema}
            onSubmit={addPost}
          >
            {({
              values,
              handleChange,
              errors,
              setFieldTouched,
              touched,
              isValid,
              handleSubmit,
            }) => (
              <Form>
                <Grid container spacing={3} className="addCommitee1">
                  <Grid item xs={12} md={12}>
                    <div className="modalInput">
                      <MailOutlineIcon />
                      <input
                      maxLength={255}
                        className="modalInputSt"
                        placeholder="Title of message"
                        value={values.postTitle}
                        onChange={handleChange("postTitle")}
                        onBlur={() => setFieldTouched("postTitle")}
                        onChangeCapture={(e) => setPostTitle(e.target.value)}
                      />
                    </div>
                    {errors.postTitle && touched.postTitle ? (
                      <div style={{ color: "red" }} className="errorField">
                        {errors.postTitle}
                      </div>
                    ) : null}
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Editor
                      value={postDesc}
                      onChangeCapture={(e) =>
                        setPostDesc(e.target.getContent())
                      }
                      apiKey="brwlomyki3gc9tg0cfqxjgiy1zgqnfeyzm3kbaakj209n34c"
                      plugins="wordcount"
                      onEditorChange={handleEditorChange}
                    />
                    {errDesc ? (
                      <div style={{ color: "red" }} className="errorField">
                        {"Required"}
                      </div>
                    ) : null}
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="atchmentMain">
                      <div className="atchMain">
                        <AttachmentOutlinedIcon />
                        <input
                          type="file"
                          id="attachmentid"
                          value={values.attachment}
                          onChange={(event) => uploadfile(event)}
                        />
                        <span>Add attachment</span>
                        <span className="formatNot">
                        Note: format allowed for document- (pdf,image,docs,xls,text)
                      </span>
                      </div>
                    </div>
                    <div className="fileName">
                      {attachment.length > 0 ? (
                        <>
                          {attachment.map((option, index) => (
                            <span className="uploaderFileOut">
                              {option.split("/").pop().replace("%20", " ")}
                              <IconButton>
                                <CloseIcon
                                  onClick={() => deleteDocument(index)}
                                />
                              </IconButton>
                            </span>
                          ))}
                        </>
                      ) : (
                        <span>No File uploaded</span>
                      )}
                      {/* <span>sampleimage.jpg</span> */}
                    </div>
                    {docErrorMsg && (
                      <div className="errorField errorFieldFForLogin forInvalidFile">
                        {docErrorMsg}
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div className="checkWrapper">
                      <div onChange={(e) => handleChangeradio(e)}>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          className="modalRadioOutNotic"
                        >
                          <FormControlLabel
                            value="all"
                            control={<Radio />}
                            label="All"
                          />
                          <FormControlLabel
                            value="committeeMembers"
                            control={<Radio />}
                            label="Committee Members"
                          />
                          <FormControlLabel
                            value="allOwners"
                            control={<Radio />}
                            label="All Owners"
                          />
                          <FormControlLabel
                            value="individual"
                            control={<Radio />}
                            label="Individual"
                          />
                          <FormControlLabel
                            value="Groups"
                            control={<Radio />}
                            label="Groups"
                          />
                        </RadioGroup>
                        {errradio ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required"}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Grid>
                  {isSelectGroup && (
                    <Grid item xs={12} md={12}>
                      <div className="refreshOut">
                        <select
                          className="modalInputStSelect"
                          value={selectedGroup}
                          onChange={handleChangeGroup}
                        >
                          <option>Select Group</option>
                          {groupsList.length > 0 ? (
                            <>
                              {groupsList.map((option) => (
                                <option
                                  key={option.group_id}
                                  value={option.group_id}
                                  data-isd={option.group_name}
                                >
                                  {option.group_name}
                                </option>
                              ))}
                            </>
                          ) : (
                            <></>
                          )}
                        </select>
                        {showerr ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required"}
                          </div>
                        ) : null}
                        <div className="refreshList">
                          <ReplayCircleFilledIcon />
                        </div>
                      </div>
                      <div className="orDivider">
                        <span>OR</span>
                      </div>
                      <div className="cretaeGroupLink">
                        <a onClick={handleClickOpen3("body")}>
                          Create New Group
                        </a>
                      </div>
                    </Grid>
                  )}
                  <>
                    {isIndividual ? (
                      <Grid item xs={12} md={12}>
                        <div className="visitorSearchDiv visitorSearchDivNotice">
                          <SearchIcon className="visitorSearchIco" />
                          <input
                            type="text"
                            placeholder="Search by phone"
                            onChangeCapture={(e) => setQ(e.target.value)}
                          />
                          {/* <MicIcon className="visitorMicIco" /> */}
                        </div>
                        {/* {residentlist.map((option) => (
                        <div
                          key={option.resident_id}
                          className={
                            membersIds.includes(option.resident_id)
                              ? "visitContDiv visitContDivNotice selectedTile"
                              : "visitContDiv visitContDivNotice"
                          }
                          onClick={() =>
                            handleChangeSelectedResident(option.resident_id)
                          }
                        >
                          <div className="visitCont1 resideNewContOut">
                            <div className="visitContProf">
                              <Zoom>
                                <img src={option.user_obj.profile_pic} />
                              </Zoom>
                            </div>
                            <div className="visitContLeft">
                              <h3 className="visitContHed">
                                {option.user_obj.first_name}{" "}
                                {option.user_obj.last_name}{" "}
                              </h3>
                              <p className="visitContMob">
                                {option.user_obj.contact_no}
                              </p>
                            </div>
                            {option.apartment ? (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                                {option.apartment.map((apartmentName) => (
                                  <b>{apartmentName.uniq_apt_name} </b>
                                ))}
                              </div>
                            ) : (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                              </div>
                            )}
                          </div>
                        </div>
                      ))} */}
                        <div className="forNoticeSelectListOuter">
                          {residentlist.map((option) => (
                            <div
                              key={option.resident_id}
                              className={
                                membersIds.includes(option.resident_id)
                                  ? "visitContDiv visitContDivNotice selectedTile draftSection"
                                  : "visitContDiv visitContDivNotice draftSection"
                              }
                              onClick={() =>
                                handleChangeSelectedResident(option.resident_id)
                              }
                            >
                              <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                                {option.apartment ? (
                                  <>
                                    {/* {option.apartment.} */}
                                    {option.apartment.map((resApt, index) => (
                                      <>
                                        {resApt.is_current_stay == true &&
                                        (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                          // {setTempCurrentStay(true)}
                                          <div className="NewTailCountOut miniBox">
                                            <div className="buildingNameNcount">
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[0]
                                                }
                                              </p>
                                              <p>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[1]
                                                }
                                              </p>
                                            </div>
                                            <h1>
                                              {
                                                resApt.uniq_apt_name.split(
                                                  "/"
                                                )[2]
                                              }
                                            </h1>
                                          </div>
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    ))}
                                    {option.currentstaycnt.count == 0 &&
                                    (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                      <div className="NewTailCountOut defaultTailCount miniBox">
                                        <div className="buildingNameNcount">
                                          <p>No Apart.</p>
                                          <p>Occupied</p>
                                        </div>
                                        <h1>F-000</h1>
                                      </div>
                                    ) : (
                                      <></>
                                    )}

                                    {option.user_type == "tenent" && (
                                      <>
                                        {option.apartment.map(
                                          (resApt, index) => (
                                            <div className="NewTailCountOut miniBox">
                                              <div className="buildingNameNcount">
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[0]
                                                  }
                                                </p>
                                                <p>
                                                  {
                                                    resApt.uniq_apt_name.split(
                                                      "/"
                                                    )[1]
                                                  }
                                                </p>
                                              </div>
                                              <h1>
                                                {
                                                  resApt.uniq_apt_name.split(
                                                    "/"
                                                  )[2]
                                                }
                                              </h1>
                                            </div>
                                          )
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <div className="NewTailCountOut defaultTailCount miniBox">
                                      <div className="buildingNameNcount">
                                        <p>No Apart.</p>
                                        <p>Occupied</p>
                                      </div>
                                      <h1>F-000</h1>
                                    </div>
                                  </>
                                )}

                                <div className="visitContProf">
                                  {option.user_obj.profile_pic ? (
                                    <Zoom>
                                      <img src={option.user_obj.profile_pic} />
                                    </Zoom>
                                  ) : (
                                    <img alt="Remy Sharp" src={avtarPic} />
                                  )}
                                </div>
                                <div className="visitContLeft">
                                  <h3 className="visitContHed">
                                    {option.user_obj.first_name}{" "}
                                    {option.user_obj.last_name}{" "}
                                  </h3>
                                  <p className="visitContMob">
                                    {option.user_obj.contact_no}
                                  </p>
                                </div>
                                <div className="visitBottCont forMyTexAlign">
                                  {option.apartment ? (
                                    <div>
                                      <>
                                        {option.apartment.map((opt) => (
                                          <>
                                            {(opt.is_current_stay == true ||
                                              opt.occupancy_type == "Vacant") &&
                                              (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                              <b className="visitContMob">
                                                {opt.uniq_apt_name}
                                                <em>{opt.occupancy_type}</em>
                                                <br />
                                              </b>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        ))}
                                      </>

                                      {option.user_type == "tenent" && (
                                        <>
                                          {option.apartment.map(
                                            (opt1, index) => (
                                              <b className="visitContMob">
                                                {opt1.uniq_apt_name}
                                                <em>{opt1.occupancy_type}</em>
                                              </b>
                                            )
                                          )}
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <div>No Apartment Allocated</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        {showerr ? (
                          <div style={{ color: "red" }} className="errorField">
                            {"Required"}
                          </div>
                        ) : null}
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </>
                  <Grid item xs={12} md={12}>
                    <div className="modalMainBtMain">
                      <Button type="submit" className="modalMainBt">
                        Create
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>
                Created Conversation <br />
                successfully
              </p>
            </div>
          </Grid>
        </Grid>
      </div>
      {/*Create Group Madal */}
      <div className="modalMain">
        <Dialog
          open={open3}
          // onClose={handleClose3}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="groupModal"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Create New Group</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose3} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Group Name</label>
                  <input
                    className="inputSt"
                    placeholder="Type Group Name"
                    value={group_name}
                    onChange={(e) => setGroupName(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Group Description</label>
                  <input
                    className="inputSt"
                    placeholder="Type Group Description"
                    value={group_description}
                    onChange={(e) => setGroupDesc(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <label className="tabsLabel">Add Members in a group</label>
                  <div className="searchOut">
                    <div className="modalInput">
                      <SearchIcon />
                      <input
                        className="modalInputSt"
                        placeholder="Search Members"
                        onChangeCapture={(e) => setQ(e.target.value)}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <div className="visitContDivScroll">
                  {residentlist.map((option) => (
                      <div
                        key={option.resident_id}
                        className={
                          membersIds.includes(option.resident_id)
                            ? "visitContDiv visitContDivNotice selectedTile draftSection"
                            : "visitContDiv visitContDivNotice draftSection"
                        }
                        onClick={() =>
                          handleChangeSelectedResident(option.resident_id)
                        }
                      >
                        <div className="visitCont1 resideNewContOut buildingNameNcountMainmini">
                          {option.apartment ? (
                            <>
                              {/* {option.apartment.} */}
                              {option.apartment.map((resApt, index) => (
                                <>
                                  {resApt.is_current_stay == true &&
                                  (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                    // {setTempCurrentStay(true)}
                                    <div className="NewTailCountOut miniBox">
                                      <div className="buildingNameNcount">
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[0]}
                                        </p>
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[1]}
                                        </p>
                                      </div>
                                      <h1>
                                        {resApt.uniq_apt_name.split("/")[2]}
                                      </h1>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ))}
                              {option.currentstaycnt.count == 0 &&
                              (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                <div className="NewTailCountOut defaultTailCount miniBox">
                                  <div className="buildingNameNcount">
                                    <p>No Apart.</p>
                                    <p>Occupied</p>
                                  </div>
                                  <h1>F-000</h1>
                                </div>
                              ) : (
                                <></>
                              )}

                              {option.user_type == "tenent" && (
                                <>
                                  {option.apartment.map((resApt, index) => (
                                    <div className="NewTailCountOut miniBox">
                                      <div className="buildingNameNcount">
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[0]}
                                        </p>
                                        <p>
                                          {resApt.uniq_apt_name.split("/")[1]}
                                        </p>
                                      </div>
                                      <h1>
                                        {resApt.uniq_apt_name.split("/")[2]}
                                      </h1>
                                    </div>
                                  ))}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="NewTailCountOut defaultTailCount miniBox">
                                <div className="buildingNameNcount">
                                  <p>No Apart.</p>
                                  <p>Occupied</p>
                                </div>
                                <h1>F-000</h1>
                              </div>
                            </>
                          )}

                          <div className="visitContProf">
                            {option.user_obj.profile_pic ? (
                              <Zoom>
                                <img src={option.user_obj.profile_pic} />
                              </Zoom>
                            ) : (
                              <img alt="Remy Sharp" src={avtarPic} />
                            )}
                          </div>
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {option.user_obj.first_name}{" "}
                              {option.user_obj.last_name}{" "}
                            </h3>
                            <p className="visitContMob">
                              {option.user_obj.contact_no}
                            </p>
                          </div>
                          {/* {option.apartment ? (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                                {option.apartment.map((apartmentName) => (
                                  <b>{apartmentName.uniq_apt_name} </b>
                                ))}
                              </div>
                            ) : (
                              <div className="visitBottCont">
                                <p>Flat Number</p>
                              </div>
                            )} */}
                          <div className="visitBottCont forMyTexAlign">
                            {option.apartment ? (
                              <div>
                                <>
                                  {option.apartment.map((opt) => (
                                    <>
                                      {(opt.is_current_stay == true ||
                                        opt.occupancy_type == "Vacant") &&
                                        (option.user_type == "Resident User" || option.user_type == "Admin Owner") ? (
                                        <b className="visitContMob">
                                          {opt.uniq_apt_name}
                                          <em>{opt.occupancy_type}</em>
                                          <br />
                                        </b>
                                      ) : (
                                        <></>
                                      )}

                                      {/* {(option.currentstaycnt.count == 0 && option.user_type == 'Resident User') && (
                                                  <b className="visitContMob">
                                                    vacant
                                                  </b>
                                                )} */}
                                    </>
                                  ))}
                                </>

                                {option.user_type == "tenent" && (
                                  <>
                                    {option.apartment.map((opt1, index) => (
                                      <b className="visitContMob">
                                        {opt1.uniq_apt_name}
                                        <em>{opt1.occupancy_type}</em>
                                      </b>
                                    ))}
                                  </>
                                )}
                              </div>
                            ) : (
                              <div>No Apartment Allocated</div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Grid>

                <Grid item xs={12} md={12}>
                  <div className="modalMainBtMain">
                    <Button
                      className="modalMainBt"
                      onClick={() => createGroup()}
                    >
                      {" "}
                      Create Group{" "}
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
export default NewConversationModal;
